import { toast } from "react-toastify";

export const composeEmail = (status, students, module) => {
  if (!Array.isArray(students) || !students.length) {
    toast.error(`There Are No Users To Send Mail.`);
    return;
  }

  const testPopup = window.open("", "_blank", "width=1,height=1");

  if (!testPopup) {
    const msg = "Popup blocked! Please allow pop-ups for this site.";
    alert(msg);
    toast.error(msg);
    return;
  }

  testPopup.close();

  const chunkSize = 200;

  let filteredStudents = students.filter((student) => {
    if (status === "all") return true;
    if (status === "enroll") return student?.courseIds?.length;
  
    const course = student.courses[student.courseIndex];
    if (!course) return false;
  
    const fees = course.feeScreenshots[module];
    return fees ? fees.status === status : status === "unpaid";
  });  

  const emails = filteredStudents
    .map(student => student?.email)
    .filter(email => email);

  if (!emails.length) {
    toast.error(`There Are No Users To Send Mail.`);
    return;
  }

  const openEmails = (startIndex = 0) => {
    const start = startIndex;
    const end = Math.min(start + chunkSize, emails.length);
    const chunk = emails.slice(start, end);
    const allEmails = chunk.join(",");

    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(allEmails)}`;
    const newTab = window.open(url, "_blank");

    if (!newTab) {
      const msg = "Popup blocked! Please allow pop-ups for this site."
      alert(msg);
      toast.error(msg);
      return;
    }

    if (end < emails.length) {
      setTimeout(() => openEmails(end), 500);
    }
  };

  openEmails();
};

export const sendEmail = (email) => {
  window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`, "_blank");
};
